import {createReducer} from "redux-act";
import {RequestState} from "modules/enums";
import {
	fetchOverallRanking,
	fetchOverallRankingSuccess,
	IRanking,
	setCurrentPage,
} from "modules/actions";

interface IRankingReducer {
	rankings: IRanking[];
	next: boolean;
	currentPage: number;
	requestState: RequestState;
}

const initialState = {
	rankings: [],
	next: false,
	currentPage: 0,
	requestState: RequestState.IDLE,
};

export const ranking = createReducer<IRankingReducer>({}, initialState)
	.on(fetchOverallRanking, (state) => ({
		...state,
		requestState: RequestState.Requested,
	}))
	.on(fetchOverallRankingSuccess, (state, payload) => ({
		...state,
		rankings: [...state.rankings, ...payload.rankings],
		next: payload.next,
		requestState: RequestState.Received,
	}))
	.on(setCurrentPage, (state, page) => ({
		...state,
		currentPage: page,
	}));
